module.exports = "<div class=\"left-menu\">\n  <div class=\"col-xs-12\">\n    <p>Companies</p>\n  </div>\n  <div class=\"col-xs-12\">\n    <select class=\"dropdown\">\n          <option>Select...</option>\n        </select>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/left-pane/left-pane.component.html
// module id = ./src/app/shared/components/left-pane/left-pane.component.html
// module chunks = main